import { ShieldX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface PMAccessDeniedProps {
  requiredPermission?: string;
}

export default function PMAccessDenied({ requiredPermission }: PMAccessDeniedProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6 text-center">
      <div className="rounded-full bg-destructive/10 p-6">
        <ShieldX className="h-12 w-12 text-destructive" />
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Access Denied</h1>
        <p className="text-muted-foreground max-w-md">
          You don't have permission to access this section.
          Contact your program administrator for access.
        </p>
      </div>
      {requiredPermission && (
        <code className="text-xs bg-muted px-3 py-1.5 rounded-md font-mono text-muted-foreground">
          Required: {requiredPermission}
        </code>
      )}
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button onClick={() => navigate('/pm')}>
          Dashboard
        </Button>
      </div>
    </div>
  );
}
